// /Users/pramod/Desktop/school-erp/frontend/src/Tenant-Admin/ManageStaff/Pagination.js
import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Pagination = ({ currentPage, totalPages, onPageChange, itemsPerPage, totalItems }) => {
  if (totalPages <= 1) return null;

  const getPages = () => {
    const pages = [];
    const maxVisible = 5;
    
    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      
      const start = Math.max(2, currentPage - 1);
      const end = Math.min(totalPages - 1, currentPage + 1);
      
      for (let i = start; i <= end; i++) {
        if (!pages.includes(i)) pages.push(i);
      }
      
      if (currentPage < totalPages - 2) pages.push('...');
      if (!pages.includes(totalPages)) pages.push(totalPages);
    }
    return pages;
  };

  return (
    <div className="mt-4 flex items-center justify-between gap-4 w-full">
      
      {/* Informative Counter Info Banner - Styled Text Context */}
      <div className="hidden sm:block">
        <p className="text-xs font-medium text-slate-400">
          Showing <span className="text-slate-800 font-bold">{((currentPage - 1) * itemsPerPage) + 1}</span> to{' '}
          <span className="text-slate-800 font-bold">{Math.min(currentPage * itemsPerPage, totalItems)}</span> of{' '}
          <span className="text-slate-800 font-bold">{totalItems}</span> entries
        </p>
      </div>
      
      {/* Action Controls Navigation Cluster */}
      <div className="flex-1 sm:flex-initial flex items-center justify-between sm:justify-end gap-1.5 w-full sm:w-auto">
        
        {/* Previous Navigation Button */}
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="flex items-center justify-center gap-1 h-9 px-3 bg-white border border-slate-200 hover:bg-slate-50 text-slate-700 disabled:opacity-40 rounded-lg text-xs font-bold transition-colors select-none flex-1 sm:flex-initial"
        >
          <ChevronLeft size={14} className="shrink-0" />
          <span>Previous</span>
        </button>

        {/* Desktop Explicit Grid Number Selectors */}
        <div className="hidden md:flex items-center gap-1">
          {getPages().map((page, idx) => (
            <button
              key={idx}
              onClick={() => typeof page === 'number' && onPageChange(page)}
              className={`w-9 h-9 flex items-center justify-center rounded-lg text-xs font-bold transition-colors select-none ${
                page === currentPage
                  ? 'bg-slate-900 text-white shadow-xs'
                  : page === '...'
                  ? 'text-slate-300 cursor-default'
                  : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900 border border-transparent'
              }`}
            >
              {page}
            </button>
          ))}
        </div>

        {/* Next Navigation Button */}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="flex items-center justify-center gap-1 h-9 px-3 bg-white border border-slate-200 hover:bg-slate-50 text-slate-700 disabled:opacity-40 rounded-lg text-xs font-bold transition-colors select-none flex-1 sm:flex-initial"
        >
          <span>Next</span>
          <ChevronRight size={14} className="shrink-0" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;